"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".row[_ngcontent-%COMP%] {\n  margin: 0 !important;\n}"];
exports.styles = styles;
//# sourceMappingURL=layer-settings.component.less.shim.ngstyle.js.map